import React, { Component } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import * as questionService from "../../../services/questionService";
import AdminWrapper from "../../../containers/AdminWrapper";
import ContentWrapper from "../../../containers/ContentWrapper";
import SelectQuestionStep from "./SelectQuestionStep";
import ReviewQuestionStep from "./ReviewQuestionStep";
import update from "immutability-helper";
import { Typography } from "@material-ui/core";

export default class AddQuestionStepper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep: 0,
      fetching: true,
      fetched: false,
      failed: false,
      submitting: false,
      questions: [],
      selectedQuestions: [],
      reviewQuestions: [],
      positions: [],
      selectedFilter: ""
    };
  }

  componentDidMount() {
    this.getUnselectedQuestions();
  }

  getUnselectedQuestions = async () => {
    try {
      this.setState({ fetching: true });
      let { clinic, created_at } = this.props.match.params;
      let { data } = await questionService.getUnselectedQuestions({
        clinic,
        created_at
      });
      data = data.map(question => {
        question.selected = false;
        return question;
      });
      let positions = data.map(question => question.position).filter((item, i, arr) => arr.indexOf(item) === i);
      this.setState({ fetching: false, failed: false, fetched: true, questions: data, positions });
      // console.log(data);
    } catch (err) {
      console.log(err);
      this.setState({ fetching: false, failed: true, fetched: true });
    }
  };

  steps = ["Select questions to be added to the shoot", "Review selected questions."];

  getStepContent = stepIndex => {
    let { fetching, fetched, failed } = this.state;
    switch (stepIndex) {
      case 0:
        return (
          <SelectQuestionStep
            {...this.props}
            questions={this.state.questions}
            selectedQuestions={this.state.selectedQuestions}
            handleSelectQuestion={this.handleSelectQuestion}
            fetching={fetching}
            fetched={fetched}
            failed={failed}
            title="Please select the questions that you want to add to the shoot."
            handleSelectedAll={this.handleSelectedAll}
            selectedFilter={this.state.selectedFilter}
            changeSelectedFilter={this.changeSelectedFilter}
            positions={this.state.positions}
          />
        );
      case 1:
        return (
          <ReviewQuestionStep
            {...this.props}
            questions={this.state.reviewQuestions}
            title="Please review the questions that you've selected."
          />
        );
      default:
        return "Unknown stepIndex";
    }
  };

  handleNextStep = () => {
    let newQuestions = this.state.questions.filter(e => this.state.selectedQuestions.includes(e.id));
    this.setState({ activeStep: this.state.activeStep + 1, reviewQuestions: newQuestions });
  };

  handleBackStep = () => this.setState({ activeStep: this.state.activeStep - 1 });

  handleSubmit = async () => {
    try {
      this.setState({ submitting: true });
      let questions = this.state.reviewQuestions;
      let { clinic, created_at } = this.props.match.params;
      await questionService.addQuestionsToShoot(
        {
          clinic,
          created_at
        },
        { questions }
      );
      this.props.history.replace(`/shoots/view/${clinic}/${created_at}/question`);
    } catch (err) {
      console.log(err);
      this.setState({ submitting: false, submitFailed: true });
    }
  };

  handleSelectedAll = () => {
    let { questions, selectedQuestions } = this.state;
    if (questions.length !== selectedQuestions.length) {
      if (this.state.selectedFilter) {
        questions = questions.filter(question => question.position == this.state.selectedFilter);
      }
      questions = questions.map(question => {
        return question.id;
      });
    } else {
      questions = [];
    }
    this.setState({ selectedQuestions: questions });
  };

  changeSelectedFilter = selectedFilter => {
    if (selectedFilter) {
      let { questions, selectedQuestions } = this.state;
      selectedQuestions = questions
        .filter(question => question.position == selectedFilter && selectedQuestions.includes(question.id))
        .map(item => item.id);
      this.setState({ selectedFilter, selectedQuestions });
    } else {
      this.setState({ selectedFilter });
    }
  };

  handleSelectQuestion = id => {
    // console.log(id);
    let { selectedQuestions } = this.state;

    if (selectedQuestions.includes(id)) {
      let index = selectedQuestions.indexOf(id);
      console.log(selectedQuestions);
      let newOutput = update({ selectedQuestions }, { selectedQuestions: { $splice: [[index, 1]] } });
      selectedQuestions = newOutput.selectedQuestions;
    } else {
      selectedQuestions = selectedQuestions.concat(id);
    }
    this.setState({ selectedQuestions });
  };

  render() {
    let { activeStep, fetching, failed, fetched } = this.state;
    let steps = this.steps;
    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Add Question">
          <div>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map(label => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <div
              style={{
                backgroundColor: "#fff",
                padding: 24
              }}
            >
              <div style={{ width: "100%", display: "flex", justifyContent: "space-between", marginBottom: 24 }}>
                <Button disabled={activeStep === 0} onClick={this.handleBackStep}>
                  Back
                </Button>
                <Button
                  variant="contained"
                  disabled={this.state.submitting}
                  color="primary"
                  onClick={activeStep === steps.length - 1 ? this.handleSubmit : this.handleNextStep}
                >
                  {activeStep === steps.length - 1 ? "Finish" : "Next"}
                </Button>
              </div>
              {this.state.submitFailed && (
                <div style={{ margin: "0 auto 20px", width: 800 }}>
                  <Typography color="error">Failed to add questions. Please try again later.</Typography>
                </div>
              )}
              {this.getStepContent(this.state.activeStep)}
            </div>
          </div>
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}
